// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"29":"7b30425e","841":"9ce14a71"}[chunkId] + ".chunk.js";
};